export const MUTATION_SET_AUTH = 'MUTATION_SET_AUTH';
export const MUTATION_SET_AUTH_ERRORS = 'MUTATION_SET_AUTH_ERRORS';
export const MUTATION_SET_AUTH_ERROR_CODE = 'MUTATION_SET_AUTH_ERROR_CODE';
export const MUTATION_REMOVE_ERRORS = 'MUTATION_REMOVE_ERRORS';
export const MUTATION_REMOVE_AUTH = 'MUTATION_REMOVE_AUTH';
